import { MissionTracking } from '../../lib/types/models/mission-tracking/mission-tracking'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionTracking(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.get.url, { id }))
    .get<MissionTracking>()
}
